// 1. 导入静态图片
import schoolPic1 from '@/assets/images/school_pic.jpg' // 南京邮电大学
import schoolPic2 from '@/assets/images/school_pic2.jpg' // 中山大学
import schoolPic3 from '@/assets/images/school_pic3.jpg' // 青岛理工

// 2. 导出默认配置（兜底使用）
export const defaultSchoolConfig = {
    image: '',
    phone: '',
}

// 3. 导出学校配置字典
export const schoolConfigMap = {
    '6210da5eaa984c8f': { // 南京邮电大学
        image: schoolPic1,
        phone: '025-88888855',
    },
    'ee0d99495b8b471f': { // 中山大学
        image: schoolPic2,
        phone: '020-84111697',
    },
    'e9f05ed07303407e': { // 青岛理工
        image: schoolPic3,
        phone: '0532-85071039',
    }
}